module.exports = __webpack_public_path__ + "static/media/IconShare.50f5bfcd.svg";